require('./dist/angular-nvd3');
module.exports = 'nvd3';


//////////////////
// WEBPACK FOOTER
// ./~/angular-nvd3/index.js
// module id = 470
// module chunks = 0